import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle, TrendingDown, Users, BarChart3, Target } from "lucide-react";

const ScalingBarriersSection: React.FC = () => {
  const barriers = [
    {
      icon: TrendingDown,
      text: "High marketing spend, low client retention.",
      color: "text-red-500"
    },
    {
      icon: Users,
      text: "Clients expect seamless booking & reminders.",
      color: "text-red-500"
    },
    {
      icon: BarChart3,
      text: "No clear data on staff or service performance.",
      color: "text-red-500"
    },
    {
      icon: AlertTriangle,
      text: "Scattered reports and poor visibility on profits.",
      color: "text-red-500"
    },
    {
      icon: Target,
      text: "Missed growth opportunities due to lack of insights",
      color: "text-red-500"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-black mb-6 leading-tight">
            What's Stopping Your Salon from 
            <span className="text-red-500 block mt-2">Scaling?</span>
          </h2>
          <div className="w-32 h-1 bg-red-500 mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {barriers.map((barrier, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group"
            >
              <div className="rounded-2xl p-6 md:p-8">
                <div className="flex items-start space-x-4">
                  <div className={`p-3 rounded-xl bg-gray-200`}>
                    <barrier.icon className={`h-6 w-6 ${barrier.color}`} />
                  </div>
                  <div className="flex-1">
                    <p className="text-black text-base md:text-lg font-medium leading-relaxed">
                      {barrier.text}
                    </p>
                  </div>
                </div>
                
                {/* Decorative element */}
                <div className="mt-4 h-1 bg-gray-300 rounded-full"></div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Image */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-12 md:mt-16"
        >
          <div className="max-w-4xl mx-auto">
            <img 
              src="/image.webp" 
              alt="Salon Growth Solutions" 
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default ScalingBarriersSection;
